import { render, staticRenderFns } from "./icyHeader.vue?vue&type=template&id=748c2905&scoped=true&"
import script from "./icyHeader.vue?vue&type=script&lang=js&"
export * from "./icyHeader.vue?vue&type=script&lang=js&"
import style0 from "./icyHeader.vue?vue&type=style&index=0&id=748c2905&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c2905",
  null
  
)

export default component.exports